import Email from '@mui/icons-material/Email'
import Button, { ButtonProps } from '@mui/material/Button'
import I18n from 'i18n-js'
import { useSnackbar } from 'notistack'

import analytics from '@src/analytics'

type NotifyPromoboxxButtonProps = Omit<ButtonProps, 'startIcon'> & {
  data?: Record<string, any>
}

const NotifyPromoboxxButton: React.FC<
  React.PropsWithChildren<NotifyPromoboxxButtonProps>
> = (props) => {
  const { data, ...muiButtonProps } = props

  const { enqueueSnackbar } = useSnackbar()

  return (
    <Button
      {...muiButtonProps}
      onClick={(event) => {
        props.onClick?.(event)
        analytics.track({
          event: 'Click',
          type: 'Notify Promoboxx',
          data: {
            ...data,
          },
        })
        enqueueSnackbar(I18n.t('notifyPromoboxx.message'), {
          variant: 'info',
        })
      }}
      startIcon={<Email />}
    >
      {I18n.t('notifyPromoboxx.label')}
    </Button>
  )
}

export default NotifyPromoboxxButton
